import { createActions, createReducer } from 'reduxsauce'

import { AuthenticationTypes } from '@galo-monitor/stores/authentication'

export const AVAILABLE_CONTEXTS = {
  root: 'root',
  company: 'company',
  farm: 'farm',
  property: 'property'
}

// Initial state
const INITIAL_STATE = {
  contexts: [],
  currentContext: null
}

/**
 * Creating actions and types with reduxsauce.
 */
const { Types, Creators } = createActions({
  loadContexts: [],
  loadContextsSuccess: ['contexts'],

  initContextById: ['contextId'],

  initContextRoot: [],
  initContextCompany: [],
  initContextFarm: ['farmId'],
  initContextProperty: [],

  exitCurrentContext: []
})


/**
 * Reducers functions
 */
const loadContextsSuccess = (state = INITIAL_STATE, { contexts }) => ({
  ...state,
  contexts
})

const initContextRoot = (state = INITIAL_STATE) => ({
  ...state,
  currentContext: AVAILABLE_CONTEXTS.root
})

const initContextCompany = (state = INITIAL_STATE) => ({
  ...state,
  currentContext: AVAILABLE_CONTEXTS.company
})

const initContextFarm = (state = INITIAL_STATE) => ({
  ...state,
  currentContext: AVAILABLE_CONTEXTS.farm
})

const initContextProperty = (state = INITIAL_STATE) => ({
  ...state,
  currentContext: AVAILABLE_CONTEXTS.property
})

const exitCurrentContext = (state = INITIAL_STATE) => ({
  ...state,
  currentContext: INITIAL_STATE.currentContext
})

const logout = () => ({ ...INITIAL_STATE })

/**
 * Creating reducer with Types.
 */
export default createReducer(INITIAL_STATE, {
  [Types.LOAD_CONTEXTS_SUCCESS]: loadContextsSuccess,
  [Types.INIT_CONTEXT_ROOT]: initContextRoot,
  [Types.INIT_CONTEXT_COMPANY]: initContextCompany,
  [Types.INIT_CONTEXT_FARM]: initContextFarm,
  [Types.INIT_CONTEXT_PROPERTY]: initContextProperty,
  [Types.EXIT_CURRENT_CONTEXT]: exitCurrentContext,

  [AuthenticationTypes.LOGOUT]: logout
})

export {
  Types as ContextTypes,
  Creators as ContextActions
}
